import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';
  
  import ScoreItem from "vue/applications/frontend/components/score-item.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-score-category',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__rec-score-category", { 'score-category--with-legend': !!_ctx.description.legend }])
  }, [
    (_ctx.description.legend)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["score-category-legend", [_unref(themingCssClass)('normal')]])
        }, _toDisplayString(_ctx.description.legend), 3))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.items, (item) => {
      return (_openBlock(), _createBlock(ScoreItem, {
        class: "score-item",
        key: item.id,
        "score-item": item
      }, null, 8, ["score-item"]))
    }), 128))
  ], 2))
}
}

})